import { BASE_URL } from 'constants/api';

import { stringify } from 'query-string';

import actions from './index';

export const ACTIONS = {
  GET: 'TRIAL_HOME_GET',
  GET_SUCCESS: 'TRIAL_HOME_SUCCESS',
  GET_FAILURE: 'TRIAL_HOME_FAILURE',
  UPDATE_CONFIG: 'UPDATE_TRIAL_HOME_PAGE_CONFIG',
  INVALIDATE_ITEM: 'TRIAL_HOME_INVALIDATE',
};

export function updateTrialPageConfig(payload) {
  return dispatch =>
    dispatch({
      type: ACTIONS.UPDATE_CONFIG,
      payload,
    });
}

export const get = actions.get(
  (_, query) => `${BASE_URL}/trial/home/?${stringify(query)}`,
  {
    PENDING: ACTIONS.GET,
    SUCCESS: ACTIONS.GET_SUCCESS,
    FAILURE: ACTIONS.GET_FAILURE,
  },
);

export const invalidateItem = () => dispatch => {
  dispatch({
    type: ACTIONS.INVALIDATE_ITEM,
  });
};
